import { KnaufPlaster } from './knauf-plaster.enum';
export enum Izolacja {
    styropian,
    welnaMineralna,
    invalid
}

export enum MaterialBudowlany {
    murowany,
    drewno,
    invalid
}

export enum Otoczenie {
    miasto,
    zbiornikWodny,
    las,
    brakSzegolow,
    invalid
}

export enum EfektDekoracyjny {
    baranek,
    kornik,
    invalid
}

export enum Odpornosc {
    zabrudzenia,
    korozjaBiologiczna,
    invalid
}

export class Ankieta {
    pytanie1a: Izolacja = Izolacja.invalid;
    pytanie1b: MaterialBudowlany = MaterialBudowlany.invalid;
    pytanie2: Otoczenie = Otoczenie.invalid;
    pytanie3: EfektDekoracyjny = EfektDekoracyjny.invalid;
    pytanie4: Odpornosc = Odpornosc.invalid;

    deserialize(input: any): Ankieta {
        var self: any = this;
        for (let prop in input) {
            self[prop] = input[prop];
        }
        return self;
    }

    public getSelectedKnaufPlaster(): KnaufPlaster {
        if (this.pytanie1b == MaterialBudowlany.murowany) {
            if (this.pytanie2 == Otoczenie.miasto) {
                if (this.pytanie3 == EfektDekoracyjny.baranek)
                    return KnaufPlaster.KnaufConniSBaranek;
                else if (this.pytanie3 == EfektDekoracyjny.kornik) {
                    return KnaufPlaster.KnaufConniRKornik;
                }
            }
            if (this.pytanie2 == Otoczenie.zbiornikWodny || this.pytanie2 == Otoczenie.las) {
                if (this.pytanie3 == EfektDekoracyjny.baranek)
                    return KnaufPlaster.KnaufKatiSBaranek;
                else if (this.pytanie3 == EfektDekoracyjny.kornik) {
                    return KnaufPlaster.KnaufKatiRKornik;
                }
            }
        }
        if (this.pytanie1b == MaterialBudowlany.drewno) {
            if (this.pytanie3 == EfektDekoracyjny.baranek)
                return KnaufPlaster.KnaufSP260Baranek;
            else if (this.pytanie3 == EfektDekoracyjny.kornik) {
                return KnaufPlaster.KnaufRP240Kornik;
            }
        }
        if (this.pytanie3 == EfektDekoracyjny.baranek) {
            if (this.pytanie4 == Odpornosc.zabrudzenia) {
                return KnaufPlaster.KnaufConniSBaranek;
            } else {
                return KnaufPlaster.KnaufKatiSBaranek;
            }
        } else {
            if (this.pytanie4 == Odpornosc.zabrudzenia) {
                return KnaufPlaster.KnaufConniRKornik;
            } else {
                return KnaufPlaster.KnaufKatiRKornik;
            }
        }
    }

    public isQuestion4Required() {
        if (this.pytanie1b == MaterialBudowlany.murowany) {
            if (this.pytanie2 == Otoczenie.miasto || this.pytanie2 == Otoczenie.zbiornikWodny || this.pytanie2 == Otoczenie.las) {
                return false;
            }
        }
        if (this.pytanie1b == MaterialBudowlany.drewno) {
            return false;
        }
        return true;
    }
}
